import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=29aa48ee&scoped=true&"
import script from "./PreviewCard.vue?vue&type=script&lang=ts&"
export * from "./PreviewCard.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=29aa48ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa48ee",
  null
  
)

export default component.exports